module.exports = __webpack_public_path__ + "img/ic_64_feature_tipprunde.56b932c3.svg";